<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :items="indexedItems"
          :item-class="getRowColor"
          :search="search"
          :single-expand="true"
          :expanded.sync="expanded"
          item-key="id"
          show-expand
          class="elevation-1"
          @item-expanded="onItemExpanded"
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->
          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>
          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.ivcf_atual="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Índice de Vulnerabilidade Clínico-Funcional da pessoa idosa."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:header.total_bp="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Percentual da(s) boa(s) prática(s) aplicável(is) realizada(s) na pessoa."
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{
              item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
            }}
            <br />
            ({{ item.idade }} {{ item.idade > 1 ? 'anos' : 'ano' }})
          </template>

          <template v-slot:item.ivcf_atual="{ item }">
            <span v-if="item.ivcf_atual">
              {{ item.ivcf_atual ?? 0 }}
            </span>
            <span v-else></span>
          </template>

          <template v-slot:item.total_bp="{ item }">
            <span>{{ item.total_bp ?? 0 }}%</span>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="9">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                    <th>Microárea</th>
                    <th>Cadastrado por</th>
                    <th v-if="exibirCopilot">Suporte</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{{ item.nu_cpf }}</td>
                    <td>{{ item.nu_cns }}</td>
                    <td>{{ item.micro_area }}</td>
                    <td>{{ item.no_profissional }}</td>
                    <td v-if="exibirCopilot">
                      <copilot :item="item" :rules="item.rules"></copilot>
                    </td>
                  </tr>
                </tbody>
              </table>

              <table class="table table-interna table-boas-praticas">
                <thead>
                  <tr>
                    <th>
                      Consultas
                      <span
                        v-b-tooltip.hover.right
                        title="(A) Ter realizado pelo menos 01 (uma) consulta por profissional médica (o) ou enfermeira (o) presencial ou remota nos últimos 12 meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Peso e altura
                      <span
                        v-b-tooltip.hover.right
                        title="(B) Ter realizado pelo menos 01 (um) registro simultâneo (no mesmo dia) de peso e altura para avaliação antropométrica nos últimos 12 meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Visitas
                      <span
                        v-b-tooltip.hover.right
                        title="(C) Ter pelo menos 02 (duas) visitas domiciliares realizadas por ACS/TACS, com intervalo mínimo de 30 (trinta) dias entre as visitas, realizadas nos últimos 12 meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      Vacinas
                      <span
                        v-b-tooltip.hover.right
                        title="(D) Ter registro de 1 (uma) dose da vacina contra influenza realizada nos últimos 12 meses."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                    <th>
                      IVCF-20
                      <span
                        v-b-tooltip.hover.right
                        title="Índice de Vulnerabilidade Clínico-Funcional."
                        class="icon-tooltip"
                      >
                        <i class="icofont-info-circle"></i>
                      </span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.a_pb == null || item.a_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('consultas', item)"
                      >
                        {{ item.a_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.b_pb == null || item.b_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('peso-altura', item)"
                      >
                        {{ item.b_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-if="item.tp_ine_fci != '76'">
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.c_pb == null || item.c_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('visitas', item)"
                      >
                        {{ item.c_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td v-else>Não se aplica</td>
                    <td>
                      <div
                        class="table-boas-praticas-item"
                        :class="
                          item.d_pb == null || item.d_pb == 0 ? 'red' : 'green'
                        "
                        @click="openModal('vacinas', item)"
                      >
                        {{ item.d_pb ?? 0 }}
                        pontos
                      </div>
                    </td>
                    <td>
                      <div
                        v-if="item.ivcf != null"
                        class="table-boas-praticas-item"
                        :class="getIvcfButtonClass(item.ivcf_atual)"
                        @click="openModal('ivcf', item)"
                      >
                        <span v-if="item.ivcf != null">
                          {{ item.ivcf_atual ?? 0 }} pontos
                        </span>

                        <span v-else>-</span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>

              <b-alert
                v-if="item.a_pb == null || item.a_pb == 0"
                variant="danger"
                show
                >Pessoa ainda sem consulta médica ou de enfermagem nos últimos
                12 meses.</b-alert
              >

              <b-alert
                v-if="item.b_pb == null || item.b_pb == 0"
                variant="danger"
                show
              >
                Pessoa ainda não tem pelo menos 01 registro de peso e altura nos
                últimos 12 meses.
              </b-alert>

              <b-alert
                v-if="item.c_pb == null || item.c_pb == 0"
                variant="danger"
                show
              >
                Pessoa ainda não tem pelo menos 02 (duas) visitas domiciliares
                realizadas por ACS, com intervalo mínimo de 30 (trinta) dias
                entre elas, nos últimos 12 meses.
              </b-alert>

              <b-alert
                v-if="item.d_pb == null || item.d_pb == 0"
                variant="danger"
                show
                >Pessoa ainda não tem dose da vacina influenza, nos últimos 12
                meses. Pode informar manualmente acima.
              </b-alert>

              <mais-indicadores-tabs
                :key="item.id"
                :cidadao="item"
                indicadorAtual="c6"
              />
            </td>
          </template>
          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>

      <b-modal
        id="modal-pessoa-idosa"
        ref="modal"
        title=""
        v-model="modal.show"
        centered
        scrollable
        hide-footer
        size="lg"
      >
        <template #modal-title> {{ modal.title }}</template>
        <div class="modal-pessoa-idosa-body" v-if="modal.item != null">
          <table
            class="table table-interna"
            v-if="modal.table.headers.length > 0"
          >
            <thead>
              <tr>
                <th
                  v-for="(itemHeader, indexHeader) in modal.table.headers"
                  :key="indexHeader"
                >
                  {{ itemHeader.label }}
                  <span
                    v-if="itemHeader.icon.show == true"
                    v-b-tooltip.hover.top
                    :title="itemHeader.icon.text"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </th>
              </tr>
            </thead>
            <!-- Consultas -->
            <tbody v-if="modal.tipo == 'consultas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fai)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_atendimento) ?? '' }}</td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
              </tr>
            </tbody>
            <!-- Peso e altura -->
            <tbody v-if="modal.tipo == 'peso-altura'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.peso_altura)"
                :key="index"
              >
                <td>{{ formatDate(item.dt_procedimento) ?? '' }}</td>
                <td>
                  {{ item.peso ?? '' }}
                </td>
                <td>
                  {{ item.altura ?? '' }}
                </td>
                <td>
                  {{ item.nu_cbo ?? '' }}
                  <span
                    v-if="item.nu_cbo != null"
                    v-b-tooltip.hover.top
                    :title="item.no_cbo"
                    class="icon-tooltip"
                  >
                    <i class="icofont-info-circle"></i>
                  </span>
                </td>
                <td>
                  {{ item.mi ?? '' }}
                </td>
              </tr>
            </tbody>
            <!-- Visitas -->
            <tbody v-if="modal.tipo == 'visitas'">
              <tr
                v-for="(item, index) in JSON.parse(modal.item.fvdt)"
                :key="index"
                :class="
                  item.dias_entre_visitas != null &&
                  Number(item.dias_entre_visitas) <= 30 &&
                  item.desfecho == 'Visita realizada'
                    ? 'green'
                    : ''
                "
              >
                <td>{{ index + 1 }}</td>
                <td>{{ formatDate(item.dt_visita) ?? '' }}</td>
                <td>{{ item.motivo_acomp }}</td>
                <td>
                  {{ item.desfecho ?? '' }}
                </td>
                <td>
                  <div v-if="item.dias_entre_visitas != null">
                    {{ item.dias_entre_visitas }}
                    {{ item.dias_entre_visitas == 1 ? 'dia' : 'dias' }}
                    ou
                    {{ Math.floor(Number(item.dias_entre_visitas) / 30) }}
                    {{
                      Math.floor(Number(item.dias_entre_visitas) / 30) == 1
                        ? 'mês'
                        : 'meses'
                    }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Vacinas -->
          <div v-if="modal.tipo == 'vacinas'">
            <div class="doses-list">
              <h4>INF3 - Vacina influenza trivalente:</h4>
              <div
                class="doses-list-item"
                :class="
                  modal.item.vacina == null || modal.item.vacina == '[]'
                    ? 'red'
                    : 'green'
                "
                @click="openModalVacina(modal.item)"
              >
                <strong>ÚNICA</strong>
                <span
                  v-if="modal.item.vacina != null && modal.item.vacina != '[]'"
                >
                  {{
                    formatDate(JSON.parse(modal.item.vacina)[0].dt_aplicacao)
                  }}
                </span>
              </div>
            </div>
            <b-modal
              id="modal2"
              title="INF3 - Vacina influenza trivalente"
              v-model="modalVacinas.show"
              :modal-class="'modal-zindex-top'"
              centered
              scrollable
              hide-footer
            >
              <ValidationObserver ref="observerModalVacinas" class="row">
                <div class="col-lg-6">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="mb-2">
                      <the-mask
                        :mask="['##/##/####']"
                        v-model="modalVacinas.form.dataAplicacao"
                        required
                        class="form-control"
                        placeholder="Data da aplicação"
                        :disabled="
                          modalVacinas.form.btn.loading ||
                          !modalVacinas.form.podeEditar
                        "
                      />
                    </div>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-lg-6">
                  <validation-provider v-slot="{ errors }" rules="required">
                    <div class="mb-2">
                      <input
                        name="lote"
                        v-model="modalVacinas.form.lote"
                        class="form-control"
                        placeholder="Lote"
                        type="text"
                        required
                        :disabled="
                          modalVacinas.form.btn.loading ||
                          !modalVacinas.form.podeEditar
                        "
                      />
                    </div>
                    <div class="error">{{ errors[0] }}</div>
                  </validation-provider>
                </div>
                <div class="col-lg-12">
                  <button
                    type="submit"
                    class="btn mt-2"
                    :disabled="
                      modalVacinas.form.btn.loading ||
                      !modalVacinas.form.podeEditar
                    "
                    v-on:click="salvarVacina(modal.item)"
                  >
                    {{
                      modalVacinas.form.mode === 'edit' ? 'Atualizar' : 'Salvar'
                    }}
                    <b-spinner
                      small
                      label="Small Spinner"
                      variant="white"
                      v-if="modalVacinas.form.btn.loading"
                    ></b-spinner>
                  </button>
                </div>
              </ValidationObserver>
            </b-modal>
          </div>

          <!-- IVCF-20 -->
          <div v-if="modal.tipo === 'ivcf'" class="ivcf-modal">
            <div class="ivcf-modal__introducao">
              <h4>IVCF-20</h4>

              <span>Índice de Vulnerabilidade Clínico-Funcional</span>

              <p>
                O IVCF-20 é um instrumento para identificação rápida da
                fragilidade da pessoa idosa.
              </p>

              <p>
                Ele é de simples e rápida aplicação (5 a 10 minutos) e tem a
                vantagem de ter caráter multidimensional, pois avalia oito
                dimensões consideradas preditoras de declínio funcional e óbito
                em pessoas idosas. Todas as perguntas são obrigatórias.
              </p>

              <p>O registro pode ser feito através de visita ao cidadão.</p>
            </div>

            <template v-if="modal.item.ivcf != null">
              <strong>Resultado</strong>

              <div
                class="ivcf-resultado"
                :class="getIvcfClassification(modal.item.ivcf_atual).className"
              >
                <strong>
                  {{ getIvcfClassification(modal.item.ivcf_atual).label }} |
                  {{ modal.item.ivcf_atual ?? 0 }} pontos
                </strong>
              </div>

              <div class="ivcf-escala">
                <div class="ivcf-escala__barra">
                  <div
                    class="ivcf-escala__faixa ivcf-escala__faixa--baixo"
                  ></div>
                  <div
                    class="ivcf-escala__faixa ivcf-escala__faixa--moderado"
                  ></div>
                  <div
                    class="ivcf-escala__faixa ivcf-escala__faixa--alto"
                  ></div>

                  <div
                    class="ivcf-escala__marcador"
                    :style="{
                      left: `${getIvcfScalePosition(modal.item.ivcf_atual)}%`,
                    }"
                  ></div>
                </div>

                <div class="ivcf-escala__numeros">
                  <span>0</span>
                  <span>7</span>
                  <span>15</span>
                  <span>40</span>
                </div>

                <!-- <div class="ivcf-escala__legenda">
                  <div>
                    <span class="legenda-cor legenda-cor--baixo"></span>
                    Baixo risco: 0 a 6
                  </div>

                  <div>
                    <span class="legenda-cor legenda-cor--moderado"></span>
                    Moderado risco: 7 a 14
                  </div>

                  <div>
                    <span class="legenda-cor legenda-cor--alto"></span>
                    Alto risco: 15 a 40
                  </div>
                </div> -->
              </div>

              <div class="ivcf-dimensoes">
                <strong>Dimensões alteradas</strong>

                <p>
                  {{
                    getIvcfAlteredDimensions(modal.item.ivcf) ||
                    'Nenhuma dimensão alterada.'
                  }}
                </p>
              </div>

              <div class="ivcf-informacoes">
                <span>
                  Registrado
                  {{ getDiasDesdeIvcf(modal.item.ivcf.dt_resultado) }}
                  por {{ modal.item.ivcf.no_profissional || '-' }}
                </span>
                <br />
                <span>({{ modal.item.ivcf.no_cbo || '-' }})</span>
              </div>
            </template>
          </div>
        </div>
      </b-modal>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import * as Functions from '../functions.js'
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import Copilot from '@/components/Copilot.vue'
import { rulesCopilot } from '../copilot.js'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    Copilot,
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
    selectedFilterBoasPraticas: {
      type: Object,
      default: () => null,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
          width: '150px',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'IVCF',
          align: 'start',
          filterable: false,
          value: 'ivcf_atual',
        },
        {
          text: 'Acompanhado',
          align: 'start',
          filterable: false,
          value: 'total_bp',
          width: '200px',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modal: {
        title: '',
        tipo: null,
        show: false,
        item: null,
        table: {
          headers: [],
        },
      },
      modalVacinas: {
        show: false,
        form: {
          dataAplicacao: null,
          lote: null,
          btn: {
            disabled: false,
            loading: false,
          },
          podeEditar: true,
          mode: 'create',
        },
      },
    }
  },
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  computed: {
    exibirCopilot() {
      // if (this.$store.state.infoMunicipio?.exibe_whatsapp == '1') {
      //   return true
      // }
      return false
    },
    indexedItems() {
      if (this.cadastros !== undefined) {
        return this.cadastros.map((item, index) => {
          return {
            id: index,
            ...item,
          }
        })
      }
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     * @returns {String}
     */
    getRowColor(item) {
      return `table-row-color-${item.rowColor}`
    },

    /**
     * Manipula o evento de expansão de um item da tabela.
     * @param {Object} item Contexto do item expandido
     */
    async onItemExpanded(item) {
      try {
        const rules = await rulesCopilot(item.item)
        Vue.set(item.item, 'rules', rules)
      } catch (error) {
        console.error('Erro ao obter as regras:', error)
      }
    },

    openModal(tipo, item) {
      this.modal.show = true
      this.modal.item = {
        ...item,
        ivcf: item.ivcf ? JSON.parse(item.ivcf) : null,
      }
      this.modal.tipo = tipo
      switch (tipo) {
        case 'consultas':
          this.modal.title = 'Consultas'
          this.modal.table.headers = [
            {
              label: 'Atendimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
          ]
          break
        case 'peso-altura':
          this.modal.title = 'Peso e altura'
          this.modal.table.headers = [
            {
              label: 'Procedimento',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Peso',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Altura',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'CBO',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'MI',
              icon: {
                show: true,
                text: 'Modelo de Informação',
              },
            },
          ]
          break
        case 'visitas':
          this.modal.title = 'Visitas'
          this.modal.table.headers = [
            {
              label: 'Nº',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Visita',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Motivo',
              icon: {
                show: true,
                text: 'Problema/Condição avaliada no atendimento',
              },
            },
            {
              label: 'Desfecho',
              icon: {
                show: false,
                text: '',
              },
            },
            {
              label: 'Tempo',
              icon: {
                show: true,
                text: 'Dias decorridos entre a visita anterior e esta.',
              },
            },
          ]
          break
        case 'vacinas':
          this.modal.title = 'Vacinas'
          this.modal.table.headers = []
          break
        case 'ivcf':
          this.modal.title = ''
          this.modal.table.headers = []
          break
        default:
          break
      }
    },

    resetFormVacina() {
      this.modalVacinas.form.dataAplicacao = null
      this.modalVacinas.form.lote = null
      this.modalVacinas.form.btn.loading = false
      this.modalVacinas.form.podeEditar = true
    },

    openModalVacina(item) {
      this.resetFormVacina()
      this.modalVacinas.form.podeEditar = true
      if (item.vacina != null && item.vacina != '[]') {
        this.modalVacinas.form.mode = 'edit'
        this.prefillFormVacina(item.vacina)
      } else {
        this.modalVacinas.form.mode = 'create'
      }
      this.modalVacinas.show = true
    },

    prefillFormVacina(item) {
      let doseParsed = JSON.parse(item)
      let dose = doseParsed[0]

      let orig = dose?.orig

      // só edita se orig == 3
      if (String(orig ?? '') !== '3') {
        this.modalVacinas.form.podeEditar = false
      }

      // lote
      if (dose?.lt != null && String(dose.lt).trim() !== '') {
        this.modalVacinas.form.lote = dose.lt
      } else {
        this.modalVacinas.form.lote = null
      }

      // data aplicação
      if (
        dose?.dt_aplicacao != null &&
        String(dose.dt_aplicacao).trim() !== ''
      ) {
        this.modalVacinas.form.dataAplicacao = this.formatDate(
          dose.dt_aplicacao
        )
      } else {
        this.modalVacinas.form.dataAplicacao = null
      }
    },

    async getCpfProfissional() {
      const res = await this.$api.post('/app/auth/usuario', {
        cod_ibge: this.$store.state.cod_ibge,
        id: this.$store.state.id,
      })

      const cpf = res?.data?.cpf
      if (!cpf) {
        return null
      }

      return cpf
    },

    async salvarVacina(item) {
      try {
        if (!this.modalVacinas.form.podeEditar) return

        const isValid = await this.$refs.observerModalVacinas.validate()

        if (!isValid) return

        this.modalVacinas.form.btn.loading = true

        const cpfProfissional = await this.getCpfProfissional()
        if (!cpfProfissional) return

        // Salvar vacina
        let response1 = await this.$api.post('/app/pessoa-idosa/vacina', {
          cod_ibge: this.$store.state.cod_ibge,
          dt_aplicacao: this.converterParaDataIso(
            this.modalVacinas.form.dataAplicacao
          ),
          cfcp: item.nu_cpf ?? item.nu_cns,
        })
        if (!response1) return

        // Salvar efb vacina
        let response2 = await this.$api.post('/app/efb-vacina', {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: item.nu_cpf ?? item.nu_cns,
          nu_cns: item.nu_cns,
          nu_cpf: item.nu_cpf,
          cpf_profissional: cpfProfissional,
          id_imunobiologico: '33',
          id_dose_imunobiologico: '9',
          lote: this.modalVacinas.form.lote,
          dt_aplicacao: this.converterParaDataIso(
            this.modalVacinas.form.dataAplicacao
          ),
        })
        if (!response2) return

        if (response1.data.error === false && response2.data.error === false) {
          this.$toast.success('Vacina salva com sucesso!', 'Sucesso:', {
            position: 'topRight',
          })
        } else {
          this.$toast.error('Erro ao salvar vacina!', 'Erro:', {
            position: 'topRight',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalVacinas.form.btn.loading = false
      }
    },

    /**
     * Retorna a classe de cor do botão IVCF.
     *
     * @param {number|null} ivcf_atual
     * @returns {String}
     */
    getIvcfButtonClass(ivcf_atual) {
      return `ivcf-button--${this.getIvcfClassification(ivcf_atual).className}`
    },

    /**
     * Retorna a classificação do IVCF-20 de acordo com a pontuação.
     *
     * @param {number|null} ivcf_atual
     * @returns {{ label: String, className: String }}
     */
    getIvcfClassification(ivcf_atual) {
      const score = Number(ivcf_atual ?? 0)

      if (score <= 6) {
        return {
          label: 'Baixo risco de vulnerabilidade clínico-funcional',
          className: 'baixo',
        }
      }

      if (score <= 14) {
        return {
          label: 'Moderado risco de vulnerabilidade clínico-funcional',
          className: 'moderado',
        }
      }

      return {
        label: 'Alto risco de vulnerabilidade clínico-funcional',
        className: 'alto',
      }
    },

    /**
     * Retorna a posição percentual da pontuação na escala de 0 a 40.
     *
     * @param {Number|null} ivcf_atual
     * @returns {Number}
     */
    getIvcfScalePosition(ivcf_atual) {
      const score = Number(ivcf_atual ?? 0)
      const limitedScore = Math.min(Math.max(score, 0), 40)

      return (limitedScore / 40) * 100
    },

    /**
     * Retorna as dimensões alteradas do IVCF-20.
     *
     * @param {Object|null} ivcf
     * @returns {String}
     */
    getIvcfAlteredDimensions(ivcf) {
      if (!ivcf) {
        return ''
      }

      const dimensions = [
        {
          field: 'st_sg_idade',
          label: 'Idade',
        },
        {
          field: 'st_sg_percepcao_saude',
          label: 'Percepção da saúde',
        },
        {
          field: 'st_sg_avd_instrumental',
          label: 'AVD Instrumental',
        },
        {
          field: 'st_sg_avd_basica',
          label: 'AVD Básica',
        },
        {
          field: 'st_sg_cognicao',
          label: 'Cognição',
        },
        {
          field: 'st_sg_humor',
          label: 'Humor',
        },
        {
          field: 'st_sg_alcance_preensao_pinca',
          label: 'Alcance, preensão e pinça',
        },
        {
          field: 'st_sg_cap_aerobica_muscular',
          label: 'Capacidade aeróbica e/ou muscular',
        },
        {
          field: 'st_sg_marcha',
          label: 'Marcha',
        },
        {
          field: 'st_sg_continencia',
          label: 'Continência esfincteriana',
        },
        {
          field: 'st_sg_visao',
          label: 'Visão',
        },
        {
          field: 'st_sg_audicao',
          label: 'Audição',
        },
        {
          field: 'st_sg_comorbidade',
          label: 'Comorbidade múltipla',
        },
      ]

      return dimensions
        .filter(({ field }) => Number(ivcf[field] || 0) > 0)
        .map(({ label }) => label)
        .join('; ')
    },

    /**
     * Retorna há quantos dias o resultado do IVCF foi registrado.
     *
     * @param {String|null} dtResultado
     * @returns {String}
     */
    getDiasDesdeIvcf(dtResultado) {
      if (!dtResultado) {
        return '-'
      }

      const dataResultado = new Date(dtResultado)

      if (Number.isNaN(dataResultado.getTime())) {
        return '-'
      }

      const agora = new Date()

      const inicioResultado = new Date(
        dataResultado.getFullYear(),
        dataResultado.getMonth(),
        dataResultado.getDate()
      )

      const inicioHoje = new Date(
        agora.getFullYear(),
        agora.getMonth(),
        agora.getDate()
      )

      const diferencaEmMilissegundos = inicioHoje - inicioResultado
      const dias = Math.floor(diferencaEmMilissegundos / (1000 * 60 * 60 * 24))

      if (dias <= 0) {
        return 'hoje'
      }

      if (dias === 1) {
        return 'há 1 dia'
      }

      return `há ${dias} dias`
    },
  },
}
</script>

<style scoped lang="scss">
.ultimo-acompanhamento {
  display: flex;
  align-items: center;
  // flex-direction: column;
  gap: 10px;
  span {
    background: #c4e8f6;
    color: #00aeef;
    padding: 5px 10px;
    border-radius: 10px;
    font-size: 11px;
  }
}

.icon-copilot {
  img {
    background: #f7f7f7;
    color: #00aeef;
    border-radius: 10px;
    text-align: center;
    width: 40px;
    padding: 10px;
  }
}

.container-table-interna {
  height: 300px;
  overflow-y: scroll;
}

.table-boas-praticas {
  .table-boas-praticas-item {
    cursor: pointer;
    background-color: #fff;
    min-width: 120px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 10px;
    border: 1px solid #ccc;
    color: #fff;
    border-radius: 6px;
    font-size: 16px;
    text-align: center;

    &.ivcf-button {
      &--baixo {
        background-color: #4caf50 !important;
        span {
          color: #fff !important;
          font-size: 16px !important;
        }
      }

      &--moderado {
        background-color: #e1bd54 !important;
        span {
          color: #fff !important;
          font-size: 16px !important;
        }
      }

      &--alto {
        background-color: #b54862 !important;
        span {
          color: #fff !important;
          font-size: 16px !important;
        }
      }
    }
  }
}

.modal-pessoa-idosa-body {
  .doses-list {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    gap: 20px;
    margin: 20px 0;
    background-color: #f1f0f5;
    padding: 15px;
    h4 {
      font-size: 16px;
      margin-bottom: 0;
    }
    .doses-list-item {
      cursor: pointer;
      background-color: #fff;
      min-width: 120px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      padding: 10px;
      border: 1px solid #ccc;
      color: #000;
      border-radius: 6px;
      &.red {
        background: #ffb3b3 !important;
        // border-color: #990000 !important;
      }
      &.green {
        background: #b3ffb3;
        // border-color: #008000 !important;
      }
      &.white {
        background: #fff;
        // border-color: #000 !important;
      }
    }
  }

  .ivcf-modal {
    color: #333;

    &__introducao {
      h4 {
        margin-bottom: 0;
        font-size: 20px;
        font-weight: 700;
      }

      > span {
        display: block;
        margin-bottom: 20px;
        color: #666;
        font-size: 13px;
      }

      p {
        margin-bottom: 10px;
        line-height: 1.5;
      }
    }
  }

  .ivcf-resultado {
    display: flex;
    flex-direction: column;
    margin: 10px 0;
    padding: 14px;
    border-radius: 6px;

    span {
      margin-bottom: 3px;
      font-size: 12px;
      font-weight: 600;
    }

    strong {
      font-size: 15px;
    }

    &.baixo {
      background-color: #d9f2e2;
      color: #176c37;
    }

    &.moderado {
      background-color: #fff1c7;
      color: #805c00;
    }

    &.alto {
      background-color: #f8d7da;
      color: #8b2630;
    }
  }

  .ivcf-escala {
    margin: 30px 0;

    &__barra {
      position: relative;
      display: flex;
      width: 100%;
      height: 12px;
      overflow: visible;
      border-radius: 20px;
    }

    &__faixa {
      height: 100%;

      &--baixo {
        width: 17.5%;
        background-color: #63b58a;
        border-radius: 20px 0 0 20px;
      }

      &--moderado {
        width: 20%;
        background-color: #e1bd54;
      }

      &--alto {
        width: 62.5%;
        background-color: #b54862;
        border-radius: 0 20px 20px 0;
      }
    }

    &__marcador {
      position: absolute;
      top: 50%;
      width: 18px;
      height: 18px;
      background-color: #fff;
      border: 4px solid #333;
      border-radius: 50%;
      transform: translate(-50%, -50%);
    }

    &__numeros {
      position: relative;
      height: 24px;
      margin-top: 7px;
      font-size: 12px;
      color: #555;

      span {
        position: absolute;
        transform: translateX(-50%);

        &:nth-child(1) {
          left: 0;
          transform: none;
        }

        &:nth-child(2) {
          left: 17.5%;
        }

        &:nth-child(3) {
          left: 37.5%;
        }

        &:nth-child(4) {
          right: 0;
          transform: none;
        }
      }
    }

    &__legenda {
      display: flex;
      flex-wrap: wrap;
      gap: 12px 20px;
      margin-top: 12px;
      font-size: 13px;

      > div {
        display: flex;
        align-items: center;
        gap: 6px;
      }
    }
  }

  .legenda-cor {
    width: 12px;
    height: 12px;
    border-radius: 50%;

    &--baixo {
      background-color: #63b58a;
    }

    &--moderado {
      background-color: #e1bd54;
    }

    &--alto {
      background-color: #b54862;
    }
  }

  .ivcf-dimensoes {
    h5 {
      margin-bottom: 12px;
      font-size: 16px;
      font-weight: 700;
    }
  }

  .ivcf-informacoes {
    margin: 20px 0;
    span {
      font-size: 14px;
      font-style: italic;
    }
  }

  @media (max-width: 768px) {
    .ivcf-informacoes {
      grid-template-columns: 1fr;
    }
  }
}
</style>
